import axios from '@/libs/axios';
import { queryClient } from '@/libs/react-query';
import { ListQueryKey, Urls } from '../constant';
import { useMutation } from '@tanstack/react-query'; //

//
export const update = data => {
  return axios.post(Urls.updateUrl, data);
};
//
export const useUpdate = ({
  config
}) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries([ListQueryKey]);
    },
    mutationFn: update,
    ...config
  });
};